import feathersClient from "../../feathers-client";

const defaultReportCancellationReasonPagination = {
	total:100,
	$skip:0,
	$limit:10,
};
const defaultReportCancellationReasonPaginationFilter = {
	$skip:defaultReportCancellationReasonPagination.$skip,
	$limit: defaultReportCancellationReasonPagination.$limit
};

export default {
	state:{
		ReportCancellationReason:[],
		ReportCancellationReasonPagination:defaultReportCancellationReasonPagination,
		ReportCancellationReasonPaginationFilter:defaultReportCancellationReasonPaginationFilter
	},
	getters:{
		setReportCancellationReasonPage:(state) => {
			const {$limit, $skip} = state.ReportCancellationReasonPagination;
			return $skip / $limit + 1;
		}

	},
	mutations:{
		SET_REPORT_CANCELLATION_REASON:(state,data) => {state.ReportCancellationReason = data;},
		SET_REPORT_CANCELLATION_REASON_PAGINATION:(state, data) => {state.ReportCancellationReasonPagination = {...state.ReportCancellationReasonPagination, ...data};},
		SET_REPORT_CANCELLATION_REASON_PAGINATION_FILTER:(state,data) => {state.ReportCancellationReasonPaginationFilter  = {...state.ReportCancellationReasonPaginationFilter, ...data};}

	},
	actions:{
		setReportCancellationReasonListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.ReportCancellationReasonPagination.$limit;
			commit('SET_REPORT_CANCELLATION_REASON_PAGINATION', { $skip });
			commit('SET_REPORT_CANCELLATION_REASON_PAGINATION_FILTER', { $skip });
		},

		getReportCancellationReason: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/reports-cancellation-reasons').find({
				query:{
					$role: rootGetters.currentUserRole,
					fields:['reason'],
					...filter
				}
			});
			commit('SET_REPORT_CANCELLATION_REASON',results.data);
			commit('SET_REPORT_CANCELLATION_REASON_PAGINATION', {total :results.total})
			return results.data;
		},
		createReportCancellationReason: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/reports-cancellation-reasons').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		updateReportCancellationReason: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/reports-cancellation-reasons').patch(data.id, data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		deleteReportCancellationReason: async ({rootGetters},id) => {
			const results = await feathersClient.service('/api/v3/reports-cancellation-reasons').remove(id,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results;
		},
		getReportCancellationReasonById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/reports-cancellation-reasons').get(id,{
				query:{
					$role: rootGetters.currentUserRole,
					fields:['reason']
				}
			});

			return results
		},
		getAllReportCancellationReasonForTrust: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/reports-cancellation-reasons').find({
				query:{
					$role:rootGetters.currentUserRole,

				}
			});
			return results;
		},
		getAllReportCancellationsReason: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/reports-cancellation-reasons').find({
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results.data;
		},
		getOptimaCancellationReason: async({rootGetters,commit}) => {
			const results = await feathersClient.service('/api/v3/optima-mappings').find({
				query:{
					$role: rootGetters.currentUserRole,
					$getCancelledReasons:true
				}
			});
			return results;
		},
		createOptimaCancellationReasonMapping: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/optima-mappings').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
					$createCancellationReasonMapping:true
				}
			});
			return results;
		},
		deleteOptimaTrustReasonMapping: async function ({ rootGetters }, data) {
			const results = await feathersClient.service('/api/v3/optima-mappings').remove(null, {
				query: {
					$deleteCancelReasonMapping: true,
					$role: rootGetters.currentUserRole,
					...data,
				},
			});
			return results;
		},

	}
}
